import { computed } from "vue";
import { useRouter } from "vue-router";

export function useIsProService() {
  const router = useRouter();
  const proPaths = ["/assurances/professionnelles/"];

  return computed(() =>
    proPaths.some((path) => router.currentRoute.value.path.includes(path))
  );
}
